import { CommonModule } from '@angular/common';
import { Component, inject, viewChild } from '@angular/core';
import { CommunitySelectorComponent } from '@components/master-layout/list-layout-wrapper/components/community-selector/community-selector.component';
import {
  NgbDropdown,
  NgbDropdownModule,
  NgbModal,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matArrowDropDownOutline,
  matFormatListBulletedOutline,
} from '@ng-icons/material-icons/outline';
import { TranslateModule } from '@ngx-translate/core';
import { isMobile } from 'detect-touch-device';
import {
  NgClickOutsideDirective,
  NgClickOutsideExcludeDirective,
} from 'ng-click-outside2';
@Component({
  selector: 'app-community-space-dropdown',
  imports: [
    NgIcon,
    CommunitySelectorComponent,
    NgbDropdownModule,
    NgClickOutsideDirective,
    NgClickOutsideExcludeDirective,
    TranslateModule,
    CommonModule,
    NgbTooltipModule,
  ],
  viewProviders: [
    provideIcons({ matArrowDropDownOutline, matFormatListBulletedOutline }),
  ],
  templateUrl: './community-space-dropdown.component.html',
})
export class CommunitySpaceDropdownComponent {
  isMobile = isMobile;
  container = null;
  communitySpaceDropdown = viewChild(NgbDropdown);

  private readonly modalService = inject(NgbModal);

  onClickOutsideDropdown(e: Event): void {
    const target = e.target as HTMLElement;

    if (target === document.body) {
      return;
    }

    if (!target.isConnected) {
      return;
    }

    e.stopPropagation();

    if (!this.modalService.hasOpenModals()) {
      this.communitySpaceDropdown()?.close();
    }
  }
}
